<a
  *ngFor="let item of menuItems; trackBy: trackByFn"
  class="shortcut-button-link"
  [style.width.px]="260"
  [href]="item.href"
  (click)="onClick($event, item.testAttribute, item.href)"
  [attr.data-test]="item.testAttribute"
  [trackClickData]="item.trackClickData"
  modeTrackClick
>
  <capra-icon
    class="identifier-icon"
    [ngClass]="{ dataset: item.icon === 'icon-dataset' }"
    [icon]="item.icon"
  ></capra-icon>
  <p class="text-container">
    <span class="title">{{ item.title }}</span>
    <span class="sub-title">{{ item.subtitle }}</span>
  </p>
  <capra-icon class="plus-icon" icon="icon-plus-global"></capra-icon>
</a>
